import React, { FC, useCallback } from 'react'
import { useReactiveVar } from '@apollo/client'

import { FilterProjectDetail } from 'modulesCommon/Filters/components'
import { projectFeedFilterVar } from 'modules/Feed/store'
import { labelCodeIdVar, labelTagsErrorVar, projectFeedTotalVar, spaceIdVar } from 'modulesCommon/store'
import { useServerError } from 'shared/hooks'
import { useTags } from 'modulesCommon/Tags/useTags'

const FilterProjectDetailsContainer: FC = () => {
  const labelTagsError = useReactiveVar(labelTagsErrorVar)
  const projectFeedTotal = useReactiveVar(projectFeedTotalVar)
  const currentLabelId = useReactiveVar(labelCodeIdVar)
  const spaceId = useReactiveVar(spaceIdVar)
  const { tags } = useTags({ labelId: currentLabelId, spaceId })

  const filterFeedHandler = useCallback((value) => projectFeedFilterVar(value?.tags || []), [])

  useServerError([labelTagsError])

  return <FilterProjectDetail tags={tags} filterEntities={filterFeedHandler} projectFeedTotal={projectFeedTotal} />
}

export default FilterProjectDetailsContainer
